<div class="modal-header" id="equipment-configuration-modal-title">
    <h3 class="modal-title" id="modal-title" [translate]="'CONFIRMATION_FOLLOWUP_SEARCH_FOR_APPOINTMENTS_LABEL'"></h3>
    <span class="close" (click)="saveDetails()">&times;</span>
</div>
<div class="modal-body">
    <form [formGroup]="confirmationAppointmentForm">
        <div class="row mb-3 align-items-center">
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_START_LABEL'"
                for="appointmentStartDate"
            ></label>
            <div class="col-lg-3">
                <pace-core-date-input
                    [(model)]="model.selectedSlotStartDate"
                    [parentForm]="confirmationAppointmentFormChildren"
                    (valueChange)="model.updateLimitsForAppointmentStart(); resetAppointmentSlotsList()"
                    id="appointmentStartDate"
                >
                </pace-core-date-input>
            </div>
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DAYS_LABEL'"
                for="appointmentDays"
            ></label>
            <div class="col-lg-2">
                <pace-core-number-stepper
                    [(model)]="model.days"
                    [parentForm]="confirmationAppointmentFormChildren"
                    (valueChange)="model.updateLimitsForDays(); resetAppointmentSlotsList()"
                    id="appointmentDays"
                    [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DAYS_LABEL' | translate"
                ></pace-core-number-stepper>
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_END_LABEL'"
                for="appointmentEndDate"
            ></label>
            <div class="col-lg-3">
                <pace-core-date-input
                    [(model)]="model.selectedSlotFinishDate"
                    [parentForm]="confirmationAppointmentFormChildren"
                    id="appointmentEndDate"
                >
                </pace-core-date-input>
            </div>
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DURATION_LABEL'"
                for="appointmentDuration"
            ></label>
            <div class="col-lg-3">
                <pace-core-duration-stepper
                    [(model)]="model.duration"
                    [parentForm]="confirmationAppointmentFormChildren"
                    id="appointmentDuration"
                    (valueChange)="resetAppointmentSlotsList()"
                    [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DURATION_LABEL' | translate"
                ></pace-core-duration-stepper>
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            @if (model.dedicatedResource) {
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DEDICATED_RESOURCE_LABEL'"
                    for="appointmentDedicatedResource"
                ></label>
                <div class="col-lg-2">
                    <pace-core-radio-input
                        [(model)]="model.dedicatedResource"
                        [parentForm]="confirmationAppointmentFormChildren"
                        id="appointmentDedicatedResource"
                        (valueChange)="resetAppointmentSlotsList()"
                    >
                    </pace-core-radio-input>
                </div>
            }
        </div>
        <div class="row mb-4 align-items-center">
            <div class="offset-lg-8 col-lg-4">
                <button
                    class="btn btn-primary"
                    type="button"
                    [disabled]="isLoading || confirmationAppointmentForm.invalid"
                    [translate]="'CONFIRMATION_FOLLOWUP_SEARCH_FOR_APPOINTMENTS_LABEL'"
                    (click)="searchForAppointments()"
                ></button>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                <div class="table-header fw-bold">
                    <div class="row align-items-center">
                        <div
                            class="col-4 offset-lg-2 col-lg-3"
                            [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DATE_LABEL'"
                        ></div>
                        <div class="col-3" [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_TIME_LABEL'"></div>
                        <div class="col-4 col-lg-3">
                            <div [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_SELECT_LABEL'"></div>
                        </div>
                    </div>
                </div>
                @if (isLoading) {
                    <progressbar [striped]="true" [value]="100">
                        {{ 'CONFIRMATION_FOLLOWUP_GETTING_APPOINTMENTS_LABEL' | translate }}
                    </progressbar>
                } @else if (!model.slotIntervals) {
                    <div class="table-row py-2">
                        <div class="col-12 text-center">
                            <span [translate]="'CONFIRMATION_FOLLOWUP_SEARCH_FOR_APPOINTMENTS_LABEL'"></span>
                        </div>
                    </div>
                } @else if (
                    model.slotIntervals && model.slotIntervals.value && model.slotIntervals.value.length === 0
                ) {
                    <div class="table-row py-2">
                        <div class="col-12 text-center">
                            <span [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_NO_SLOTS_AVAILABLE_LABEL'"></span>
                        </div>
                    </div>
                } @else {
                    @for (slot of model.slotIntervals?.value; track slot.startDateAndTime) {
                        <div class="table-row py-2">
                            <pace-appointment-slot-row
                                [row]="slot"
                                [index]="$index"
                                (slotSelect)="bookSlot($event)"
                            ></pace-appointment-slot-row>
                        </div>
                    }
                }
            </div>
        </div>
    </form>
</div>
